module.exports = new __parcel__URL__("success.e3e14e6e.png").toString();